<header class="header">

  <button
    class="header__menu-toggle"
    type="button"
    (click)="sidebarSvc.toggle()"
    [attr.aria-expanded]="sidebarSvc.isOpen()"
    aria-controls="sidebar-nav"
    aria-label="Abrir menú de navegación"
  >
    <svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.5"
      viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round"
      xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path d="M4.5 6.5h15M4.5 12h15m-15 5.5h15"/>
    </svg>
  </button>

  <nav class="header__breadcrumbs hidden! lg:flex!" aria-label="Ruta de navegación">
    @for (crumb of breadcrumbs(); track $index; let last = $last) {

      @if (crumb.isHome) {
        <a class="header__crumb header__crumb--icon" [routerLink]="crumb.route" [attr.aria-label]="crumb.label">
          <svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.5"
            viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round"
            xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M6.133 21C4.955 21 4 20.02 4 18.81v-8.802c0-.665.295-1.295.8-1.71l5.867-4.818a2.09 2.09 0 0 1 2.666 0l5.866 4.818c.506.415.801 1.045.801 1.71v8.802c0 1.21-.955 2.19-2.133 2.19z"/>
            <path d="M9.5 21v-5.5a2 2 0 0 1 2-2h1a2 2 0 0 1 2 2V21"/>
          </svg>
        </a>
      } @else if (!last && crumb.route) {
        <a class="header__crumb header__crumb--link" [routerLink]="crumb.route">
          {{ crumb.label }}
        </a>
      } @else {
        <span class="header__crumb" [class.header__crumb--current]="last">
          {{ crumb.label }}
        </span>
      }

      @if (!last) {
        <span class="header__crumb-sep" aria-hidden="true">
          <svg width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.5"
            viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round"
            xmlns="http://www.w3.org/2000/svg">
            <path d="m9 18 6-6-6-6"/>
          </svg>
        </span>
      }
    }
  </nav>

  <div class="header__actions">

    <div class="header__user" [class.header__user--open]="menuOpen()">
      <button
        class="header__user-toggle"
        type="button"
        (click)="toggleMenu()"
        aria-haspopup="true"
        [attr.aria-expanded]="menuOpen()"
      >
        <span class="header__avatar" aria-hidden="true">{{ iniciales() }}</span>

        <span class="header__user-info">
          <span class="header__user-name">{{ user().nombre }}</span>
          <span class="header__user-dni">
            <span class="header__user-dni-label">DNI:&nbsp;</span>{{ user().dni }}
          </span>
        </span>

        <span class="header__chevron" [class.header__chevron--rotated]="menuOpen()" aria-hidden="true">
          <svg width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.5"
            viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round"
            xmlns="http://www.w3.org/2000/svg">
            <path d="m6 9 6 6 6-6"/>
          </svg>
        </span>
      </button>

      @if (menuOpen()) {
        <div class="header__dropdown" role="menu" aria-label="Menú de usuario">
          @for (option of userMenu(); track option.action) {
            <button class="header__dropdown-item" type="button" role="menuitem">
              {{ option.label }}
            </button>
          }
        </div>
      }
    </div>

    <button class="header__notifications" type="button" aria-label="Notificaciones">
      <svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.5"
        viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round"
        xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="M15.019 17h-6.04m6.04 0h3.614c1.876 0 1.559-1.86.61-2.804C15.825 10.801 20.68 3 11.999 3s-3.825 7.8-7.243 11.196c-.913.908-1.302 2.804.61 2.804H8.98m6.039 0c0 1.925-.648 4-3.02 4s-3.02-2.075-3.02-4"/>
      </svg>
      <span class="header__notifications-badge" aria-hidden="true"></span>
    </button>

  </div>
</header>
